const SPLIT_CLASSES_REGEX = /\s+/

type ClassGroup = 'border' | 'w' | 'h' | 'bg' | 'p' | 'pt' | 'pr' | 'pb' | 'pl' | 'px' | 'py' | 'm' | 'mt' | 'mr' | 'mb' | 'ml' | 'mx' | 'my'

const getClassGroupId = (className: string): ClassGroup | null => {
  const patterns: { regex: RegExp, group: ClassGroup }[] = [
    { regex: /^border-/, group: 'border' },
    { regex: /^w-/, group: 'w' },
    { regex: /^h-/, group: 'h' },
    { regex: /^bg-/, group: 'bg' },
    { regex: /^p-/, group: 'p' },
    { regex: /^pt-/, group: 'pt' },
    { regex: /^pr-/, group: 'pr' },
    { regex: /^pb-/, group: 'pb' },
    { regex: /^pl-/, group: 'pl' },
    { regex: /^px-/, group: 'px' },
    { regex: /^py-/, group: 'py' },
    { regex: /^m-/, group: 'm' },
    { regex: /^mt-/, group: 'mt' },
    { regex: /^mr-/, group: 'mr' },
    { regex: /^mb-/, group: 'mb' },
    { regex: /^ml-/, group: 'ml' },
    { regex: /^mx-/, group: 'mx' },
    { regex: /^my-/, group: 'my' }
  ]

  for (const { regex, group } of patterns) {
    if (regex.test(className)) return group
  }

  return null
}

export const classMerge = (...classList: (string | undefined | null)[]): string => {
  const classGroupsInConflict: ClassGroup[] = []
  const classNames = classList.filter(Boolean).join(' ').split(SPLIT_CLASSES_REGEX)
  let result = ''

  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index]
    const classGroupId = getClassGroupId(originalClassName)

    if (!classGroupId) {
      result = originalClassName + (result.length > 0 ? ' ' + result : result)
      continue
    }

    if (!classGroupsInConflict.includes(classGroupId)) {
      classGroupsInConflict.push(classGroupId)
      result = originalClassName + (result.length > 0 ? ' ' + result : result)
    }
  }

  return result
}
